import { render, staticRenderFns } from "./promotion-detail-goods-store.vue?vue&type=template&id=32d2d49c&"
import script from "./promotion-detail-goods-store.vue?vue&type=script&lang=js&"
export * from "./promotion-detail-goods-store.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports